import { Users, Eye, Video, ThumbsUp, MessageCircle, Clock, Calendar, Zap, Globe } from "lucide-react";
import { formatCompact, formatDate, formatRelative } from "@/lib/format";

const Stat = ({ icon: Icon, label, value, sub, testId }) => (
  <div
    data-testid={testId}
    className="card-flat card-hover p-6 flex flex-col justify-between min-h-[130px]"
  >
    <div className="flex items-center justify-between">
      <div className="overline">{label}</div>
      <Icon className="w-4 h-4 text-muted-foreground" aria-hidden="true" />
    </div>
    <div>
      <div className="text-3xl font-black tabular-nums tracking-tight mt-4">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1 font-mono">{sub}</div>}
    </div>
  </div>
);

export default function StatsGrid({ stats }) {
  if (!stats) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
      <div className="flex items-baseline justify-between mb-4">
        <h2 className="text-2xl font-bold tracking-tight">Key Statistics</h2>
        <div className="overline">Current snapshot</div>
      </div>
      <div data-testid="stats-grid" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <Stat testId="stat-subscribers" icon={Users} label="Subscribers" value={formatCompact(stats.subscribers)} sub={`${(stats.subscribers || 0).toLocaleString("en-US")} total`} />
        <Stat testId="stat-total-views" icon={Eye} label="Total views" value={formatCompact(stats.total_views)} />
        <Stat testId="stat-video-count" icon={Video} label="Videos" value={formatCompact(stats.video_count)} />
        <Stat testId="stat-avg-views" icon={Eye} label="Avg. views" value={formatCompact(stats.avg_views)} sub="per video" />
        <Stat testId="stat-avg-likes" icon={ThumbsUp} label="Avg. likes" value={formatCompact(stats.avg_likes)} />
        <Stat testId="stat-avg-comments" icon={MessageCircle} label="Avg. comments" value={formatCompact(stats.avg_comments)} />
        <Stat testId="stat-avg-gap" icon={Clock} label="Upload cadence" value={stats.avg_gap_days ? `${stats.avg_gap_days}d` : "—"} sub="between uploads" />
        <Stat testId="stat-last-video" icon={Calendar} label="Last video" value={formatRelative(stats.last_video_at)} sub={formatDate(stats.last_video_at)} />
        <Stat testId="stat-engagement" icon={Zap} label="Engagement" value={`${stats.engagement_rate}%`} sub="likes+comments / views" />
        <Stat testId="stat-country" icon={Globe} label="Country / Language" value={stats.country || "—"} sub={stats.default_language || "n/a"} />
      </div>
    </section>
  );
}
